<template>
  <div class="container">
    <!-- <nav-bar rightShow="false" @leftClick="leftClick"></nav-bar> -->
    <div class="item-cont">
      <div class="pic" :style="{backgroundImage: 'url('+ imgUrl +')'}"></div>
      <div class="menu-content">
        <menu-list name="设备ID" :subName="deviceIdex" rightIcon="false"></menu-list>
        <menu-list name="硬件版本" :subName="yingjian" rightIcon="false"></menu-list>
        <menu-list name="软件版本" :subName="ruanjian" rightIcon="false"></menu-list>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import axios from 'axios'
import Common from '../../assets/js/common.js'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    NavBar,
    MenuList
  },
  data () {
    return {
      imgUrl: Common.staticHref() + 'img/eqLogo.jpg',
      diviceId: localStorage.getItem('max_device_id'),
      deviceIdex: '',
      yingjian: '',
      ruanjian: ''
    }
  },
  methods: {
    leftClick () {
      this.$router.back()
    },
    goPage (e) {
      if (e === 'equipment') {
        this.$router.push({path: '/AboutEquipment'})
      } else if (e === 'version') {
        this.$router.push({path: '/VersonUpdate'})
      }
    },
    getEquipmentInfo () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/version/get/device/version/info/', {
          'device_id': this.diviceId
        })
        .then(this.getEquipmentInfoSucc)
        .catch(this.getEquipmentInfoError)
      } else {
        axios.post(api + '/Calendar/api/version/get/device/version/info/', {
          'device_id': this.diviceId
        })
        .then(this.getEquipmentInfoSucc)
        .catch(this.getEquipmentInfoError)
      }
    },
    getEquipmentInfoSucc (res) {
      let _res = res.data
      this.toast.hide()
      if (_res) {
        let _result = _res.result
        if (_result === 0) {
          this.deviceIdex = _res.info.device_id_ex
          this.yingjian = _res.info.hardware
          this.ruanjian = _res.info.software
        } else if (_result === 1) {
          console.log(_res.message)
        }
      }
    },
    getEquipmentInfoError (error) {
      this.toast.hide()
      console.log(error)
    }
  },
  created () {
    Common.setTitle('关于设备')
    this.getEquipmentInfo()
  }
}
</script>
<style lang="stylus" scoped>
.item-cont
  background-color #ffffff
  border-top 1px solid #ededed
  padding-top 4.97vh
  .pic
    height 19.8vh
    width calc(19.8vh * 0.619)
    margin 0 auto
    background-position center center
    background-repeat no-repeat
    background-size contain
  .menu-content
    padding 4.97vh 16px 0
    background #ffffff
</style>



// WEBPACK FOOTER //
// src/pages/AboutEquipment/AboutEquipment.vue